<template>
  <div>
    <div class="topNav" id="tab">
      <div id="appNav">
        <ul class="van-clearfix topTab">
          <li :class="{ curr: currentTab == '' }" @click="changeTab('')">
            全部
          </li>
          <li :class="{ curr: currentTab == 7 }" @click="changeTab(7)">
            待核销
          </li>
          <li :class="{ curr: currentTab == 5 }" @click="changeTab(5)">
            已完成
          </li>
          <li :class="{ curr: currentTab == 6 }" @click="changeTab(6)">
            已退款
          </li>
          <li :class="{ curr: currentTab == 8 }" @click="changeTab(8)">
            退款申请
          </li>
        </ul>
      </div>
    </div>
    <!-- 重要勿删 -->
    <!--    <div class="commonPadding" style="display: none">-->
    <!--      <div v-if="orderList.length > 0" class="van-clearfix">-->
    <!--        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">-->
    <!--          <van-list v-model="isUpLoading" :finished="upFinished" :immediate-check="false"-->
    <!--                    :offset="offset" finished-text="我是有底线的" @load="onLoadList">-->
    <!--            <ul class="orderList van-clearfix" v-if="orderList.length > 0">-->
    <!--              <li class="actLi" v-for="(item,index) in orderList" :key="index" @click="orderDetail(item)">-->
    <!--                <div class="liDivWrap">-->
    <!--                  <div class="proImg">-->
    <!--                    <img :src="baseImg + item.imgUrl" alt="" class="imgPic">-->
    <!--                  </div>-->
    <!--                  <div class="van-clearfix detail">-->
    <!--                    <div>{{item.wikiName}}</div>-->
    <!--                    <div>{{item.desc}}</div>-->
    <!--                    <div class="priceNum">-->
    <!--                      <div class="priceDive">￥{{item.visitCount}}</div>-->
    <!--                      <div class="action">-->
    <!--                        <div>X1</div>-->
    <!--                        <div>-->
    <!--                          <span class="btn" @click.stop="showBox = true">确认收货</span>-->
    <!--                          <span class="btn" @click.stop="buyAgain">再次购买</span>-->
    <!--                          <span class="btn">立即支付</span>-->
    <!--                        </div>-->
    <!--                      </div>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->

    <!--              </li>-->
    <!--            </ul>-->
    <!--          </van-list>-->
    <!--        </van-pull-refresh>-->
    <!--      </div>-->
    <!--      <div v-else>-->
    <!--        <img src="@/assets/img/noAct.png" class="noAct" />-->
    <!--        <div class="actText">暂无订单</div>-->
    <!--      </div>-->
    <!--    </div>-->
    <div v-if="orderList.length > 0" class="van-clearfix">
      <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
        <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :immediate-check="false"
          :offset="offset"
          finished-text=""
          @load="onLoadList"
        >
          <ul class="orderList van-clearfix" v-if="orderList.length > 0">
            <li
              class="actLi van-clearfix"
              v-for="(item, index) in orderList"
              :key="index"
              @click="orderDetail(item)"
            > 
              <div class="boxTitle" v-if="item.orderStatus == 8">
                <div class="status02">退款申请</div>
              </div>
              <div class="boxTitle" v-if="item.orderStatus == 7">
                <div class="status02">待核销</div>
              </div>
              <div class="boxTitle" v-if="item.orderStatus == 5">
                <div class="status04">已完成</div>
              </div>
              <div class="boxTitle" v-if="item.orderStatus == 6">
                <div class="status04">已退款</div>
              </div>
              <div class="flexBetween">
                <div
                  class="flexOne allFlexCenter"
                  v-if="item.orderItems.length == 1"
                >
                  <div class="common_proImg">
                    <img
                      :src="baseImg + item.orderItems[0].goodsThumbnail"
                      alt=""
                    />
                  </div>
                  <div class="common_pro_detail">
                    <div class="common_pro_sku">
                      {{ item.orderItems[0].goodsName }}
                    </div>
                  </div>
                </div>
                <div class="flexOne allFlexCenter" v-else>
                  <div
                    class="common_proImg"
                    v-for="(itemWrap, indexWrap) in item.orderItems"
                  >
                    <img :src="baseImg + itemWrap.goodsThumbnail" alt="" />
                  </div>
                </div>
                <div class="rightPart">
                  <div class="pro_value">
                    <span class="pro_unit">￥</span
                    ><span>{{ item.integerPrice }}</span
                    ><span class="pro_decimals">.{{ item.decimalsPrice }}</span>
                  </div>
                  <div class="allNum">共{{ item.orderItems.length }}件</div>
                </div>
              </div>
              <!-- 1待核销2已完成3已退款 -->
              <div class="van-clearfix btnRight">
                <div v-if="item.orderStatus == 5 || item.orderStatus == 6" class="btnEnd">
                  <div
                    class="smallBtn active"
                    @click.stop="reAddCart(item.orderItems[0].goodsId,item.orderItems[0].sellerId)"
                  >
                    再次购买
                  </div>
                </div>
                <div v-else-if="item.orderStatus == 7" class="btnEnd">
                  <div class="smallBtn" @click.stop="isRefund(item,index)">申请退款</div>
                  <div
                    class="smallBtn blue"
                    @click.stop="isSureGet(item, index)"
                  >
                    立即核销
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </van-list>
      </van-pull-refresh>
    </div>
    <div v-if="orderList.length == 0 && upFinished">
      <img src="@/assets/img/noAct.png" class="noAct" />
      <div class="actText">暂无订单</div>
    </div>
    <van-popup v-model="showBox" position="bottom">
      <div class="popGoodsTitle">确认核销订单？</div>
      <div class="popText">为避免造成损失，请确认到店消费再核销</div>
      <div class="goodsBtn">
        <div class="flexCenter" style="width: 100%">
          <div
            class="heightBtn long borderActive"
            @click.stop="showBox = false"
          >
            取消
          </div>
          <div class="heightBtn active long" @click.stop="confirmWriteOff">
            确定核销
          </div>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showBox1" position="bottom">
      <div class="popGoodsTitle">确认申请退款？</div>
      <div class="popText">申请后，将由门店审核退款</div>
      <div class="goodsBtn">
        <div class="flexCenter" style="width: 100%">
          <div
            class="heightBtn long borderActive"
            @click.stop="showBox1 = false"
          >
            取消
          </div>
          <div class="heightBtn active long" @click.stop="applyForRefund">
            确定退款
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  removeParams,
  removeUser,
  getToken,
  setToken,
  setUid,
  setIsSystem,
  removeToken,
  getCode,
  getUid,
  removeCode,
  removeUid
} from "utils/auth";
import {
  parseTime,
  getUrlParam,
  isWeixin,
  countdown,
  formatPrice
} from "utils/index";
import { CODE_OK } from "utils/publicData";
import EnvionmentVariables from "../../../../baseUrl";
export default {
  name: "todayActivity",
  components: {},
  data () {
    return {
      active: 0,
      baseImg: EnvionmentVariables.IMAGE_HOST,
      orderList: [],
      tabAct: false,
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 6, // 每页请求的数量
      total: 0, // 总共的数据条数
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      currentTab: "",
      showBox: false,
      showBox1: false,
      status: "",
      orderIndex: "",
      orderId: undefined,
      refundAmount: undefined
    };
  },
  beforeCreate () {
    document
      .querySelector("body")
      .setAttribute("style", "background-color: #F8F8F8;");
  },
  created () {
    var token = this.$route.query.appToken;
    if (token) {
      setToken(token);
    }
    this.getClubOrderByPage();
  },
  mounted () {
    // var that = this;
    // this.orderList.forEach(function (item, index) {
    //   if (item.status == 1) {
    //     countdown(item.residueTime, index, function (res) {
    //       item.rocallTime = res;
    //       that.$forceUpdate();
    //     });
    //   }
    // })
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
  },
  // 页面销毁时，取消监听。否则其他vue路由页面也会被监听
  destroyed () {
    // debugger
    // window.removeEventListener('popstate', this.goBack, false);
  },
  methods: {
    goBack () {
      // 个人中心进入返回上一级，支付后进入返回首页
      if (!this.$route.query.type) {
        this.$router.replace({ path: "/goodDetails", query: { id: 49 } });
      } else {
        history.go(-1);
      }
    },
    // 是否申请退款
    isRefund (item, orderIndex) {
      this.showBox1 = true;
      this.orderId = item.orderId;
      this.orderIndex = orderIndex;
    },
    // 是否核销订单
    isSureGet (item, orderIndex) {
      this.showBox = true;
      this.orderId = item.orderId;
      this.orderIndex = orderIndex;
      this.refundAmount = item.totalAmount;
    },
    // 确认核销
    confirmWriteOff (item) {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          confirmType: 2,
          orderId: this.orderId
        }
      };
      this.$api.getOrderConfirm(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.$toast("核销成功");
            that.showBox = false;
            that.orderList[this.orderIndex].orderStatus=5;
          }
        }
      });
    },
    // 确认申请退款
    applyForRefund (item) {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.orderId,
          refundAmount: this.refundAmount
        }
      };
      this.$api.getMemOrderRefundApply(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            that.$toast("申请成功");
            that.showBox1 = false;
            that.orderList[this.orderIndex].orderStatus=8;
          }
        }
      });
    },
    // 再次购买
    reAddCart (id,businessId) {
      var that = this;
      that.$router.push({ path: "/placeOrder", query: { from: 1 ,id:id,businessId:businessId} });
    //   var param = {
    //     service: "appagg",
    //     query: {
    //       orderId: orderId,
    //     },
    //   };
    //   this.$api.reCreate(param).then((res) => {
    //     if (res) {
    //       if (res.data.basis.status === 200) {
    //         // that.$toast("操作成功");
    //         // setTimeout(function () {
    //         that.$router.push({ path: "/shopCart", query: {} });
    //         // },1000)
    //       }
    //     }
    //   });
    },
    // 确定收货
    getGoods () {
      var that = this;
      var param = {
        service: "appagg",
        query: {
          id: this.orderId
        }
      };
      this.$api.receiveGoods(param).then((res) => {
        if (res) {
          if (res.data.basis.status === 200) {
            if (!this.currentTab) {
              this.orderList[this.orderIndex].orderStatus = 5;
            } else {
              this.orderList.splice(this.orderIndex, 1);
            }
            this.showBox = false;
          }
        }
      });
    },
    getPic (url) {
      return require(url);
    },
    orderDetail (item) {
      this.$router.push({
        path: "/projectOrderDetail",
        query: {
          status: item.orderStatus,
          orderId: item.orderId,
          paymentOrderId: item.paymentOrderId
        }
      });
    },
    buyAgain () {
      this.$router.push({ path: "/confirmOrder", query: {} });
    },
    receiverConfirm () {
      this.$dialog
        .confirm({
          title: "温馨提示",
          message: "是否要确认收货",
          confirmButtonText: "确认收货"
        })
        .then(() => {
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    // 1待付款2已取消3待发货4待收货5已完成6已退款
    changeTab (currentTab) {
      this.currentTab = currentTab;
      this.pageIndex = 1; // 请求第几页
      // this.pageSize = 10; // 每页请求的数量
      this.total = 0; // 总共的数据条数
      this.isDownLoading = false; // 下拉刷新
      this.isUpLoading = false; // 上拉加载
      this.upFinished = false; // 上拉加载完毕
      this.orderList = [];
      this.status = currentTab;
      this.getClubOrderByPage();
    },
    // 获取资讯列表
    getClubOrderByPage (index) {
      var that = this;
      var statusArray = [];
      if (this.currentTab) {
        if (this.currentTab == 4) {
          statusArray = [3, 4];
        } else {
          statusArray.push(this.currentTab);
        }
      }
      var param = {
        service: "appagg",
        query: statusArray,
        pageIndex: that.pageIndex,
        pageSize: that.pageSize
      };
      this.$api
        .getClubOrderByPage(param)
        .then((res) => {
          if (res) {
            that.total = res.data.rows;
            // 数据全部加载完成
            if (that.orderList.length >= that.total) {
              that.upFinished = true; // 加载结束
            } else {
              res.data.result.forEach(function (item, index) {
                if (item.orderStatus == 1) {
                  that.computetTime(
                    item,
                    index,
                    item.currentTime,
                    item.createTime
                  );
                }
              });
              that.orderList = that.orderList.concat(res.data.result);
            }
            if (res.data.result.length < that.pageSize) {
              that.upFinished = true;
            }
            console.log(that.orderList);
            // that.orderList.forEach(function (item, index) {
            that.orderList.forEach(function (item, index) {
              // if (item.orderStatus == 1) {
              //   // countdown(item.createTime, index, function (res) {
              //   //   item.rocallTime = res;
              //   //   that.$forceUpdate();
              //   // });
              //   that.computetTime(item, index, item.currentTime ,item.createTime);
              // }
              var price = formatPrice(item.totalAmount);
              item.integerPrice = price.integerPrice;
              item.decimalsPrice = price.decimalsPrice;
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          console.log("finally");
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    computetTime (item, index, nowTime, createTime) {
      var that = this;
      var ct = createTime.replace(/\-/g, "/"); // 创建订单时间
      var st = nowTime.replace(/\-/g, "/"); // 服务器当前时间
      var ts = new Date(st).getTime();
      var tc = new Date(ct).getTime();
      var cm = (30 * 60 * 1000 - (ts - tc)) / 1000;
      var timerIndex = "timer" + index;
      timerIndex = setInterval(() => {
        cm -= 1;
        that.runBack(item, cm);
        if (cm < 1) {
          item.rocallTime = "00:00:00";
          clearInterval(timerIndex);
          that.orderList.splice(index, 1);
        }
      }, 1000);
    },
    runBack (item, cm) {
      var min = parseInt(cm / 60);
      min = min > 9 ? min : `0${min}`;
      let sec = parseInt(cm % 60);
      sec = sec > 9 ? sec : `0${sec}`;
      item.rocallTime = `00:${min}:${sec}`;
      this.$forceUpdate();
    },
    // 下拉刷新.
    onDownRefresh () {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.orderList = [];
        this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getClubOrderByPage(this.article_type); // 加载数据
        this.timer = null; // 清空定时器
      }, 300);
    },
    // 上拉加载
    onLoadList () {
      this.pageIndex++;
      this.getClubOrderByPage(this.article_type);
    }
  }
};
</script>

  <style scoped lang="less">
.goodsBtn {
  padding-bottom: 48px;
}
.borderActive{
    border: 2px solid #B1B1B2;
    color: #3C4041;
}
.van-popup{
    border-radius: 12px 12px 0px 0px;
}
.popGoodsTitle {
//   padding-top: 70px;
//   padding-bottom: 84px;
  padding-top: 40px;
  padding-bottom: 40px;
  font-size: 32px;
  color: #3e3e3e;
  text-align: center;
  font-weight: bold;
}
.popText {
  font-size: 28px;
  font-weight: 400;
  color: #3e3e3e;
  line-height: 20px;
  text-align: center;
  padding-bottom:68px;
}
/*.orderList > .actLi:last-child{*/
/*  margin-bottom: 32px;*/
/*}*/
.common_proImg > img {
  width: 149px;
  height: 149px;
  display: block;
}
.btnRight {
  margin: 33px 0;
}
.allNum {
  color: #b1b1b2;
  font-size: 20px;
  text-align: right;
  margin-top: 3px;
}
.pro_decimals {
  font-weight: bold;
  color: #3e3e3e;
  font-size: 20px;
}
.pro_unit {
  color: #3e3e3e;
  font-size: 20px;
  font-weight: bold;
}
.pro_value {
  color: #3e3e3e;
  font-size: 29px;
  font-weight: bold;
  text-align: right;
}
.pro_value > span {
  font-weight: bold;
}
.common_pro_detail {
  width: 334px;
}
.common_pro_sku {
  width: 334px;
}
.rightPart {
  width: 144px;
}
.boxTitle {
  padding-top: 41px;
  padding-bottom: 33px;
}
.status01 {
  color: #ff3e29;
  font-size: 24px;
}
.status02 {
  width: 113px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(53, 125, 250, 0.11);
  border-radius: 8px;
  color: #357dfa;
  font-size: 24px;
}
.status03 {
  width: 113px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(177, 177, 178, 0.21);
  border-radius: 8px;
  color: #b1b1b2;
  font-size: 24px;
}
.status04 {
  width: 113px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  background: rgba(177, 177, 178, 0.21);
  border-radius: 8px;
  color: #3e3e3e;
  font-size: 24px;
}
.btn {
  background-color: transparent;
  color: #515151;
  border: 1px solid #c3c5c6;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  line-height: 58px;
  border-radius: 5px;
  padding: 5px;
  margin-left: 10px;
  font-size: 26px;
}
.action {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.detail > div {
  margin-bottom: 20px;
}
.detail {
  flex: 1;
  font-size: 32px;
}
.proImg {
  width: 170px;
}
.proImg > img {
  width: 150px;
  height: 150px;
  display: block;
}
.liDivWrap {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  padding: 20px 0;
  border-bottom: 0.013333rem solid #f7f5f5;
}
.orderList {
  width: 100%;
  /*background: #fff;*/
  margin-top: 32px;
}
.topTab li.curr::after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 46px;
  height: 7px;
  display: block;
  content: "";
  background: #3e3e3e;
  border-radius: 4px;
}
.topTab li.curr {
  position: relative;
  font-weight: bold;
}
.topTab > li {
  flex: 1;
  display: inline-block;
  font-size: 30px;
  height: 90px;
  line-height: 90px;
  text-align: center;
  color: #3e3e3e;
}
.topTab {
  height: 90px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1;
  display: flex;
  margin-bottom: 33px;
}
.desc {
  font-size: 26px;
  color: #999;
  height: 60px;
}
.proName {
  font-size: 30px;
  margin: 10px;
  color: #1e2221;
  height: 60px;
}
.imgPic {
  width: 317px;
  height: 317px;
  display: block;
  margin: 0px auto;
  border-radius: 10px;
}
.actLi {
  min-height: 320px;
  padding: 0 32px;
  margin-top: 16px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: #fff;
}
.search_icon {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 0.5rem;
  top: 25px;
  z-index: 1000;
}
.s_input {
  padding: 0 0.3rem;
  position: relative;
}
.searchInput {
  border: 1px solid #d1d1d1;
  border-radius: 0.7rem;
  padding-left: 70px;
}
.inputTop {
  height: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.2rem;
}
.flexOne {
  flex: 1;
}
.carIcon {
  width: 1rem;
  height: 1rem;
  margin: auto;
  display: block;
}
.car {
  width: 1.5rem;
}
.noAct {
  width: 3rem;
  height: 3rem;
  display: block;
  margin: 1rem auto 1rem;
}
.actText {
  font-size: 0.3rem;
  text-align: center;
  color: #999;
}
.topNav {
  width: 100%;
  //position: fixed;
  box-sizing: border-box;
  height: 88px;
  line-height: 88px;
  top: 0;
  z-index: 1000;
}
#tab {
  position: relative;
  height: 110px;
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 0px 0px 12px 12px;
  background: #fff;
}
#appNav {
  width: 100%;
  height: 88px;
  overflow: hidden;
  position: absolute;
  left: 0;
  top: 0;
  background: #fff1f0;
}
#appNav nav {
  padding: 0 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: middle;
  -ms-flex-align: middle;
  align-items: middle;
  overflow: auto;
}
#appNav p {
  text-align: center;
  font-size: 28px;
  -ms-flex-negative: 0;
  flex-shrink: 0;
  padding: 0px 50px;
  height: 100%;
  position: relative;
}
#appNav p.active {
  color: #e52317;
}
#appNav p.active::after {
  content: "";
  display: block;
  position: absolute;
  width: 45px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 4px;
  background: #e52317;
  border-radius: 2px;
}
#appNav p.active[data-v-1258668a] {
  color: #e52317;
}
.blue {
  color: #357dfa;
  border: 2px solid #357dfa;
}
.smallBtn {
  float: left;
}
.btnEnd {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.line16 {
  width: 100%;
  height: 16px;
  background: #f8f8f8;
}
</style>
